import React from 'react';
import ReactDOM from 'react-dom';
import '@/assets/tailwindcss/styles.css';
import '@/assets/less/index.less';
import App from './App';
import * as serviceWorker from './serviceWorker';
import MainProvider from '@/contexts/MainProvider';
import * as dotenv from 'dotenv';
import {RegisterRegisteredProvider} from '@/modules/clientRegisters/hooks/useRegisterRegistered';
import {RunAuditOnlineStatusProvider} from '@/contexts/RunAuditOnlineStatusProvider';
import {GoogleOAuthProvider} from '@react-oauth/google';

dotenv.config();

ReactDOM.render(
  <GoogleOAuthProvider clientId={process.env.REACT_APP_GOOGLE_CLIENT_ID}>
    <MainProvider>
      <RunAuditOnlineStatusProvider>
        <RegisterRegisteredProvider>
          <App/>
        </RegisterRegisteredProvider>
      </RunAuditOnlineStatusProvider>
    </MainProvider>
  </GoogleOAuthProvider>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
